import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/seo-audit")({
  component: lazyRouteComponent(() => import("./-pages/admin.seo-audit")),
  head: () => ({
    meta: [
      { title: "SEO Audit · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
